<template>
  <div class="extratoContainer">
    <div style="display: flex;    align-items: center; padding-bottom: 10px;">
      <div class="tabRecarga">
          <span @click="selectTab">Viagens</span>
          <span @click="selectTab">Recarga</span>
          <span class="select" @click="selectTab" >Todos</span>
      </div>
      <div @click="toggleModal()" v-if="isMobile()" class="filtrar-mobile"></div>
    </div>
    <div class="overlay" v-if="modalFilterMobile" @click="toggleModal()"></div>
    <div class="divFilter" v-if="!isMobile() || modalFilterMobile">
      <span class="first" style="float:left;">De</span>
      <div class="data-selects">
        <div class="div-select dia custom-arrow">
          <select v-model="diaInicial" class="styled-select">
              <option value="">Dia</option> 
              <option :key="index" v-for="(item,index) in this.retornaArray(31)">
                {{item.toString().length > 1 ? item.toString() : "0"+item.toString()}}            
              </option>
          </select>
        </div>
        <div class="div-select mes custom-arrow">
          <select v-model="mesInicial" class="styled-select">
            <option value="">Mes</option> 
            <option value="01">Janeiro</option>
            <option value="02">Fevereiro</option>
            <option value="03">Março</option>
            <option value="04">Abril</option>
            <option value="05">Maio</option>
            <option value="06">Junho</option>
            <option value="07">Julho</option>
            <option value="08">Agosto</option>
            <option value="09">Setembro</option>
            <option value="10">Outubro</option>
            <option value="11">Novembro</option>
            <option value="12">Dezembro</option>
          </select>
        </div>
        <div class="div-select ano custom-arrow">
           <select v-model="anoInicial" class="styled-select">
           <option value="">Ano</option> 
            <option :key="index" v-for="(item,index) in this.retornaArray(new Date().getFullYear() +5,new Date().getFullYear() - 5)">
                {{item}}            
            </option>
          </select>
        </div>
        <span style="float:left;" class="a first">a</span>
        <div class="div-select dia custom-arrow">
          <select v-model="diaFinal" class="styled-select">
            <option value="">Dia</option> 
            <option :key="index" v-for="(item,index) in this.retornaArray(31)">
            {{item.toString().length > 1 ? item.toString() : "0"+item.toString()}} 
              </option>

          </select>
        </div>
        <div class="div-select mes custom-arrow">
          <select v-model="mesFinal" class="styled-select">
              <option value="">Mes</option> 
              <option value="01">Janeiro</option>
              <option value="02">Fevereiro</option>
              <option value="03">Março</option>
              <option value="04">Abril</option>
              <option value="05">Maio</option>
              <option value="06">Junho</option>
              <option value="07">Julho</option>
              <option value="08">Agosto</option>
              <option value="09">Setembro</option>
              <option value="10">Outubro</option>
              <option value="11">Novembro</option>
              <option value="12">Dezembro</option>

          </select>
        </div>
        <div class="div-select ano custom-arrow">
          <select v-model="anoFinal" class="styled-select">
            <option value="">Ano</option> 
            <option :key="index" v-for="(item,index) in this.retornaArray(new Date().getFullYear() +5,new Date().getFullYear() - 5)">
                {{item}}            
            </option>
          </select>
        </div>
      </div>
      <div class="valor-inputs">
        <span style="float:left;">De</span>
        <input v-money="money" type="text" maxlength="9"  v-model.number="valorInicial">
        <span style="float:left;">a</span>
        <input v-money="money" type="text" maxlength="9"  v-model.number="valorFinal">
        <a @click="filtraValores"  class="btn block-extrato">ir</a>
      </div>
      
    </div>
    <div v-if="loading" style="padding: 25px; text-align: center" class="loading-bar">
      <v-progress-circular
      indeterminate
      color="#723387"
    ></v-progress-circular>
    </div>
    <ul class="filterList" v-if="!loading">
       <div v-if="!giroCard && !_filter()">
          <p>Não existe cartão Giro vinculado a sua conta.</p>
        </div>
        <div v-if="giroCard && _filter() && _filter().length == 0">
          <p>Não há histórico para o período selecionado. Altere o filtro acima ou realize uma recarga.</p>
        </div>
      <li v-else :key="index" v-for="(item,index) in _filter()" :class="item.OPERATION">
        <div>
          <div class="info">
            <strong>{{ item.DATETIME }} -</strong>
            <span>
                <div v-if="item.OPERATION == 'CASHBACK'"><i class="giro-icon-presente"></i> Pague e receba de volta</div>
                <div v-if="item.OPERATION == 'PENDENTE' || item.OPERATION == 'CREDITO'">
                    <div>Recarga APP - Crédito -</div>
                    <div>Status: {{ item.PAYMENTMETHOD }} - </div>
                    <div>{{ item.STATION }}</div>
                </div>
                <div v-if="item.OPERATION == 'EVENTO'">
                    <div>Evento -</div>
                    <div>{{ item.STATION }}</div>
                </div>
                <div v-if="item.OPERATION == 'DEBITO'">
                  <div>Passagem utilizada - {{ item.STATION }}</div>
                </div>
            </span>
        </div>
        <div class="valor">
            <span v-if="item.OPERATION == 'CREDITO' || item.OPERATION == 'CASHBACK'">+ {{ formatMoney(item.VALUE) }}</span>
            <span v-if="item.OPERATION == 'DEBITO'">- {{ formatMoney(item.VALUE) }}</span>
            <span v-if="item.OPERATION == 'PENDENTE'">( {{ formatMoney(item.VALUE) }} )</span>
        </div>
      </div>
    </li>
  </ul>
</div>
</template>
<script>
import {resolvePromise,emitToParent,retornaArray,isMobile} from '../helpers/helpers'
import {cardHistory} from '../services/sbe.service'
import { VProgressCircular } from "vuetify/lib";
export default {
  name: 'FilterList',
  components: {
    VProgressCircular
  },
  data(){
    return{
      loading: true,
      modalFilterMobile: false,
      filterBy: 'Todos',
      diaInicial:'',
      mesInicial:'',
      anoInicial:'',
      diaFinal:'',
      mesFinal:'',
      anoFinal:'',
      valorInicial:'0,00',
      valorFinal:'500,00',
       money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            suffix: '',
            precision: 2,
            masked: false,
          }    
      }
  },
  computed:{
    dtIni:function(){
      return  this.anoInicial + "-" + this.mesInicial + "-" + this.diaInicial
    },
    dtFim:function(){
      return  this.anoFinal + "-" + this.mesFinal + "-" + this.diaFinal
    }
  },
  methods:{
    retornaArray,
    isMobile,
    toggleModal(){
      this.modalFilterMobile = !this.modalFilterMobile;
    },
    _filter() {
      if(this.filterBy == 'Viagens') {
        return (this.userExtrato||[]).filter(v => v.OPERATION == 'DEBITO');
      } else if(this.filterBy == 'Recarga') {
        return (this.userExtrato||[]).filter(v => v.OPERATION == 'CREDITO' || v.OPERATION == 'CASHBACK');
      } else {
        return (this.userExtrato||[]);
      }
    },
    formatMoney(value) {
      value = (value).trim();
      let formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },
    filtraValores(){
      this.loading = true;
        const
      {dtIni,dtFim,valorInicial,valorFinal} = this
      console.log({dtIni,dtFim})
      let valIni = valorInicial.replace(/[^0-9.,]+/,'').replace(',','.');
      let valFim = valorFinal.replace(/[^0-9.,]+/,'').replace(',','.');
      this.modalFilterMobile = false;
      resolvePromise(cardHistory(this.giroCard,dtIni,dtFim,valIni,valFim),({data})=>{
        emitToParent("returnExtrato",this,data);
        this.loading = false;
      },(err) => {
        console.log(err);
        this.loading = false;
      },this)
    },
    selectTab(e){
      Array.from(document.querySelectorAll('.tabRecarga span')).forEach(node=>node.classList.remove('select')) 
      e.target.classList.toggle("select");
      this.filterBy = e.target.innerText;
    }
  },
  props: {
    userExtrato:{
      type:Array
    },
    giroCard:{
      type:String
    }
  },
  created(){
    const
      {userExtrato,giroCard } = this;
      let today = new Date();
      let lastWeek = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));
      this.diaInicial = ("0"+(lastWeek.getUTCDate()+1)).substr(-2);
      this.mesInicial = ("0"+(lastWeek.getUTCMonth()+1)).substr(-2);
      this.anoInicial = lastWeek.getFullYear();

      this.diaFinal = ("0"+(today.getUTCDate()+1)).substr(-2);
      this.mesFinal = ("0"+(today.getUTCMonth()+1)).substr(-2);
      this.anoFinal = today.getFullYear();
    this.loading = false;
    if(!userExtrato && giroCard){
      this.filtraValores();
    }/* (
      resolvePromise(cardHistory(giroCard),({data})=>emitToParent("returnExtrato",this,data),console.log,this)
    )*/
  }
}
</script>

<style scoped lang="scss">
.divFilter{
  display: flex;
  align-items: center;
  span.first{
    //padding: 36px 0;
  }
}
.tabRecarga span{
  margin: 0 20px;
  cursor: pointer;
  &.select{
    font-weight: 900;
  }
}
@media(max-width: 780px){
  .tabRecarga {
    display: flex;
    flex: 1;
    justify-content: space-around;
    span {
      margin: 0;
    }
  }
  .extratoContainer {
    .data-selects {
      flex-wrap: wrap;
      
      .div-select.dia {width: 25%; padding: 0 2px; margin: 0}
      .a { width: 100%; margin-top: 10px; }
      .div-select.mes {width: 50%; padding: 0 2px; margin: 0}
      .div-select.ano {width: 25%; padding: 0 2px; margin: 0}
      .styled-select {
        width: 100% !important;
        font-size: 16px !important;
      }
      
    }
    .valor-inputs {
      flex-wrap: wrap;
      .block-extrato { min-width: auto; border-radius: 5px; }
    }

  }
  .filtrar-mobile {
    width: 30px;
    height: 30px;
    background: url("../assets/img/filtrosimbolo.png") center no-repeat;
    background-size: 80%;
  }
  .overlay {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0,0,0,0.6);  
    z-index: 99999;
  }
}
.block-extrato{
    width: 17%;
    padding: 0;
    margin: 0;
    margin-left: 10px;
    border-radius: 5px;
        line-height: 47px;
}
.extratoContainer{
  .data-selects,.valor-inputs{
    overflow: hidden;
    margin: 2% 0;
    height: auto;
    display: inline-flex;
    align-items: center;
    font-size: 18px;
  }
  .data-selects{
    width: 85%;
    // float: left;
  }
  .valor-inputs{
    // float: left;
    input{
      border-style: none;
      float: left;
      height: 47px;
      margin: 0 1%;
      width: 30%;
      background-color: #723387;
      border-radius: 5px;
      color: #fff;
      text-align: center;
      &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: #fff;
            opacity: 1; /* Firefox */
          }
    }
    .form-group{
      width: 49%;
      float: left;
      padding: 0;
      .block-extrato{
        margin: 0;
        border-radius:5px;
        width: 10%;
        padding: 10px;
      }
    }
  }
  span{
    //padding: 14px 0;
  }
  .filterList{
    margin: 0 5%;
    list-style: none;
    li{
      margin:40px 0;
      position: relative;;
      color: #777;
      &:before {
        content: "";
        background: #312163;
        width: 9px;
        height: 9px;
        border-radius: 100%;
        position: absolute;
        left: -20px;
        top: 5px;
      }
      &:after {
        content: '';
        width: 1px;
        /* height: 100%; */
        position: absolute;
        left: -16px;
        background: #312163;
        display: block;
        top: 5px;
        bottom: -50px;
      }
      &:last-child {
          &:after {
          display: none;
        }
      }
      &.CASHBACK,
        &.CREDITO {
          color: #69ae82;
        }
      > div {
        display:flex;
        align-items: flex-start;
        
        .info {
          display: flex;
          align-items: flex-start;
          flex:1;
          > span {
            display: flex;
            align-items: flex-start;
            flex:1;
            > div {
              display: flex;
              align-items: flex-start;
              flex: 1;
              flex-wrap: wrap;
              padding: 0 10px;
              > div {
                padding-right: 5px;
              }
            }
          }
        }
        .valor {
        }
      }
    }
  }
  .div-select{
      overflow: hidden;
      width: 20%;
      float: left;   
      &.custom-arrow{ 
        position: relative;
        margin-right: 5px;
        &::before {
          content: "";
          pointer-events: none;
          width: 35px;
          height: 100%;
          background: #671176;
          position: absolute;
          right: 0;
          z-index: 1;
          border-radius: 0 5px 5px 0;
        }
        &::after {
          content: "";
          pointer-events: none;
          width: 15px;
          height: 20px;
          background: no-repeat center center;
          background-size: contain;
          background-image: url("../assets/img/arrow-down-sign-to-navigate.svg");
          position: absolute;
          right: 10px;
          top: 50%;
          margin-top: -10px;
          z-index: 2;
        }
      } 
    .styled-select { 
        width: 100%;
        background-color: #723387;
        background-image: url("../assets/img/arrow-down-sign-to-navigate.svg");
        background-size: 20px;
        color: #fff;
        padding:0 4%;
        border-radius: 5px;
        background-position: calc(100% - 10px) center;
        padding-right: 35px;
        height:48px;
        font-size:18px;
        text-indent: 0.01px;
        text-overflow: ellipsis;
        select::-ms-expand {
          display: none;
        }
    }
    &.dia{
      margin-left: 1%;
      .styled-select{
            //background-size: 25% 60%;
            //background-position: 41px center;
      }
    }
    &.mes{
      .styled-select{
        //background-size: 15% 60%;
        //background-position: 87% center;
      }

    }
    &.ano{
      .styled-select{
        //background-size: 23% 60%;
        //background-position: 80% center;
      }
    }
  } 
}
@media(max-width:780px) {
  .divFilter {
    display: flex;
    flex-direction: column;
    position: fixed;
    left: 3%;
    width: 94%;
    background: white;
    z-index: 99999;
    padding: 10px;
    top: 20%;
    align-items: flex-start;
    span.first {
      padding: 0 0 10px 0;
    }
    
  }
  .extratoContainer {
      .data-selects {
        width: 100% !important;
        align-items: center;
      }
      .styled-select {
        text-align-last: center;
        text-align: center;
      }
      .valor-inputs {
        align-items: center;
      }
      .filterList li > div .info {
        flex-direction: column;
         > span > div {
           padding: 0;
           flex-direction: column;
         }
      }
    }
}

</style>
